import React from 'react';
import { useT, useL } from '../../lib/lessonI18n';

const QUAD = 'M12,8 L88,8 L74,92 L26,92 Z';
// POS (0-100 square) → inside the trapezoid.
const M = ([x, y]) => { const yy = 8 + y * 0.84; const l = 12 + (yy - 8) * (14 / 84); const r = 88 - (yy - 8) * (14 / 84); return [l + (x / 100) * (r - l), yy]; };
const OFF = { 'ə': [0, 8], 'ɚ': [0, 8], 'ɒ': [5.5, 1.5], 'ɑː': [-5.5, 1.5], 'ɑ': [-5.5, 1.5], 'ɔː': [5, 1.5], 'ɔ': [5, 1.5] };

// Interactive IPA trapezoid: RP (cyan/orange) and GA (lime) points, selected glow and diphthong glide.
export const Trapezoid = ({ points: raw, sel, glide: g, onPick, replayKey, tid = 'vowel-trapezoid', ptPrefix = 'trap-pt', gaBelow }) => {
  const T = useT();
  const points = raw.map((p) => { const [x, y] = M([p.x, p.y]); return { ...p, x, y }; });
  const glide = g && { from: M(g.from), to: M(g.to) };
  const rpIpa = new Set(points.filter((p) => !p.ga).map((p) => p.ipa));
  return (
  <svg viewBox="-16 -7 116 107" className="w-full h-full" data-testid={tid}>
    <path d={QUAD} fill="rgba(34,211,238,0.04)" stroke="rgba(34,211,238,0.3)" strokeWidth="0.6" />
    {[8, 36, 64, 92].map((y) => <line key={y} x1={12 + (y - 8) * (14 / 84)} y1={y} x2={88 - (y - 8) * (14 / 84)} y2={y} stroke="rgba(148,163,184,0.12)" strokeWidth="0.3" />)}
    <line x1="50" y1="8" x2="50" y2="92" stroke="rgba(148,163,184,0.12)" strokeWidth="0.3" />
    {[T('Chiuse', 'Close'), T('Semi-chiuse', 'Close-mid'), T('Semi-aperte', 'Open-mid'), T('Aperte', 'Open')].map((t, i) => <text key={i} textAnchor="end" x={11 + i * 28 * (14 / 84)} y={9 + i * 28} fontSize="2.8" fill="#64748b">{t}</text>)}
    {[T('Anteriori', 'Front'), T('Centrali', 'Central'), T('Posteriori', 'Back')].map((t, i) => <text key={i} x={18 + i * 32} y="-2" fontSize="2.8" fill="#64748b" textAnchor="middle">{t}</text>)}
    {glide && (
      <g key={replayKey}>
        <line x1={glide.from[0]} y1={glide.from[1]} x2={glide.to[0]} y2={glide.to[1]} stroke="rgba(251,146,60,0.6)" strokeWidth="0.9" strokeDasharray="2 2" />
        <circle r="2.6" fill="#fb923c" style={{ filter: 'drop-shadow(0 0 3px rgba(251,146,60,0.9))' }}>
          <animate attributeName="cx" values={`${glide.from[0]};${glide.from[0]};${glide.to[0]}`} keyTimes="0;0.45;1" dur="1.4s" fill="freeze" />
          <animate attributeName="cy" values={`${glide.from[1]};${glide.from[1]};${glide.to[1]}`} keyTimes="0;0.45;1" dur="1.4s" fill="freeze" />
        </circle>
      </g>
    )}
    {points.map((p) => {
      const on = sel === p.key;
      const fill = p.ga ? 'rgba(163,230,53,0.95)' : p.rounded ? 'rgba(251,146,60,0.9)' : 'rgba(34,211,238,0.9)';
      return (
        <g key={p.key} onClick={() => onPick(p)} className="cursor-pointer" data-testid={`${ptPrefix}-${p.key}`}>
          {on && <circle cx={p.x} cy={p.y} r="6" fill="rgba(251,146,60,0.35)" className="ct-pulse" />}
          <circle cx={p.x} cy={p.y} r="5" fill="transparent" />
          <circle cx={p.x} cy={p.y} r={on ? 2.8 : 2.1} fill={fill} />
          {!(gaBelow && p.ga && rpIpa.has(p.ipa)) && <text x={p.x + (OFF[p.ipa]?.[0] ?? 0)} y={gaBelow && p.ga ? p.y + 5.6 : p.y - 3.6 + (OFF[p.ipa]?.[1] ?? 0)} fontSize="4.3" textAnchor="middle" fill="#e2e8f0" style={{ fontWeight: 700 }}>{p.ipa}</text>}
        </g>
      );
    })}
  </svg>
  );
};
